module.exports = __webpack_public_path__ + "media/images/activeIconGuidance-365b800a.png";